//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Sends a patient information request message
 */
export function sendPatientRequestMessage(dto: Types.SendHL7PatientRequestDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/hl7/out-messages/patient-request";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeSendHL7PatientRequestDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendPatientRequestMessage,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendPatientRequestMessage?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendPatientRequestMessage(_response);
    });
}

function processSendPatientRequestMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Sends message regarding measurement
The measurement id.
Request parameter
 */
export function sendMeasurementMessage(measurementId: number, dto: Types.SendHL7MessageDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/hl7/out-messages/measurement/{measurementId}";
    if (measurementId === undefined || measurementId === null)
      throw new Error("The parameter 'measurementId' must be defined.");
    url_ = url_.replace("{measurementId}", encodeURIComponent("" + measurementId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeSendHL7MessageDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendMeasurementMessage,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendMeasurementMessage?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendMeasurementMessage(_response);
    });
}

function processSendMeasurementMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Sends message regarding document
The document id.
Request parameter
 */
export function sendDocumentMessage(documentId: string, dto: Types.SendHL7MessageDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/hl7/out-messages/document/{documentId}";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeSendHL7MessageDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendDocumentMessage,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendDocumentMessage?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendDocumentMessage(_response);
    });
}

function processSendDocumentMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigSendPatientRequestMessage: Partial<AxiosRequestConfig> | null;
export function getSendPatientRequestMessageRequestConfig() {
  return _requestConfigSendPatientRequestMessage;
}
export function setSendPatientRequestMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendPatientRequestMessage = value;
}
export function patchSendPatientRequestMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendPatientRequestMessage = patch(_requestConfigSendPatientRequestMessage ?? {});
}

let _requestConfigSendMeasurementMessage: Partial<AxiosRequestConfig> | null;
export function getSendMeasurementMessageRequestConfig() {
  return _requestConfigSendMeasurementMessage;
}
export function setSendMeasurementMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendMeasurementMessage = value;
}
export function patchSendMeasurementMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendMeasurementMessage = patch(_requestConfigSendMeasurementMessage ?? {});
}

let _requestConfigSendDocumentMessage: Partial<AxiosRequestConfig> | null;
export function getSendDocumentMessageRequestConfig() {
  return _requestConfigSendDocumentMessage;
}
export function setSendDocumentMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendDocumentMessage = value;
}
export function patchSendDocumentMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendDocumentMessage = patch(_requestConfigSendDocumentMessage ?? {});
}